import gql from 'graphql-tag';

export default gql`
  fragment salesforceTaskProspectActivityFragment on SalesforceTaskProspectActivity {
    id
    activityDate
    description
    salesforceTaskIdString
    subject
    taskSubtype
  }
`;
